var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-link',{on:{"click":_vm.goBack}},[_c('font-awesome-icon',{staticClass:"mr-2 text-primary",attrs:{"icon":"backward"}}),_vm._t("default",[_vm._v("\n      Go back\n    ")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }